import React from 'react';

// Helpers
import NumberUtils from 'helpers/numberUtils';

const numberUtils = new NumberUtils();

const PricingInformation = ({ financialDetails }) => {
  return (
    <div className="max-w-2xl mx-auto p-6 bg-white">
      <h2 className="text-2xl font-bold text-red-500 text-center mb-6">
        Pricing Information
      </h2>

      <div className="grid grid-cols-2 gap-x-12 gap-y-4 mb-6">
        {/* Left Column */}
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="font-bold">Submission Cost</span>
            <span className="text-right">
              {financialDetails?.submissionCost
                ? numberUtils.formatToCurrency(
                    financialDetails?.submissionCost
                  )
                : 'Loading...'}
            </span>
          </div>
          <div className="flex justify-between">
            <div className="flex items-start">
              <span className="font-bold">Service Fee</span>
              <span className="text-xs align-top">*</span>
            </div>
            <span className="text-right">
              {financialDetails?.fee
                ? numberUtils.formatToCurrency(financialDetails?.fee)
                : 'Loading...'}
            </span>
          </div>
          <div className="flex justify-between font-bold border-t pt-2">
            <span>Total Cost</span>
            <span className="text-right font-bold">
              {financialDetails?.totalCost
                ? numberUtils.formatToCurrency(
                    financialDetails?.totalCost
                  )
                : 'Loading...'}
            </span>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="font-bold">Down Payment</span>
            <span className="text-right">
              {financialDetails?.downPayment && financialDetails?.fee
                ? numberUtils.formatToCurrency(
                    financialDetails?.downPayment +
                      financialDetails?.fee
                  )
                : 'Loading...'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-bold">Monthly Payment</span>
            <span className="text-right">
              {financialDetails?.paymentAmount
                ? numberUtils.formatToCurrency(
                    financialDetails?.paymentAmount
                  )
                : 'Loading...'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-bold"># of Payments</span>
            <span className="text-right">
              {financialDetails?.numberOfPayments
                ? financialDetails?.numberOfPayments
                : 'Loading...'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-bold">Effective APR</span>
            <span className="text-right">
              {financialDetails?.effectiveAPR
                ? `${financialDetails?.effectiveAPR}%`
                : 'Loading...'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-bold">Finance Company</span>
            <span className="text-right">
              {financialDetails?.premiumFinanceProvider.toUpperCase() ??
                ''}
            </span>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <p className="text-xs text-gray-600 mt-4">
        *All Service Fees are fully earned and are collected as part
        of the down payment. In some circumstances, Cover Badger is
        unable to add the service fee to the PFA. In these cases, it
        will be the responsibility of the retail agent to collect this
        fee directly from the insured at the time of binding the
        submission.
      </p>
    </div>
  );
};

export default PricingInformation;
